import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Wrapper from './WrapperOLD';
import Button from '../../components/Button';
import { TemplateField } from '../../components/Attributes/Attributes_old';

import useSearchParams from '../../hooks/useSearchParams';
import useAsync from '../../hooks/useAsync';

import { userFetchAccessToken } from '../../api';

const SSOSignIn = ({}) => {
	const navigate = useNavigate();
	const [formState, setFormState] = useState({});
	const [error, setError] = useState(null);
	const accessRef = useRef();
	const [accessCode, setAccessCode] = useState('');

	const { access_code } = useSearchParams();

	const {
		value: loadedToken,
		execute: onFetchToken,
		status,
	} = useAsync(userFetchAccessToken, {
		immediate: false,
		showNotification: true,
	});

	useEffect(() => {
		if (access_code) {
			onFetchToken({ accessCode: access_code });
		}
	}, [access_code]);

	useEffect(() => {
		if (loadedToken?.id) {
			navigate(`/login/new?token=${loadedToken?.token}`);
		}
	}, [loadedToken]);

	const handleAccessChange = (index, newAccessCode) => {
		//const newAccessCode = e.target.value;
		const isDashed = newAccessCode[newAccessCode.length - 1] === '-';
		const isDeleting = newAccessCode.length < accessCode.length;

		if (isDashed) {
			setAccessCode(newAccessCode.substring(0, newAccessCode.length - 1));
		} else if (newAccessCode.length === 4 && !isDeleting) {
			setAccessCode(`${newAccessCode}-`);
		} else {
			setAccessCode(newAccessCode);
		}

		if (newAccessCode.length === 9) {
			onFetchToken({ accessCode: newAccessCode });
		}
	};

	return (
		<Wrapper title="Login with an Access Code" message={error}>
			<div className="space-y-6">
				<div>
					<TemplateField
						name="Enter access code"
						ref={accessRef}
						placeholder="Access code"
						value={accessCode}
						onChange={handleAccessChange}
						maxLength={9}
						autoFocus
					/>
				</div>
				<div className="flex justify-between">
					<Button
						type="ghost"
						className="flex-shrink-0"
						onClick={() => navigate('/login')}
					>
						Go back
					</Button>
					<Button
						type="primary"
						className="flex-shrink-0"
						onClick={() =>
							onFetchToken(formState, () => navigate('/login'))
						}
					>
						{status === 'pending' ? 'Loading...' : 'Login'}
					</Button>
				</div>
			</div>
		</Wrapper>
	);
};

export default SSOSignIn;
